import { supabase } from '../supabaseClient';

export type TutorialProgressRow = {
  tutorialId: string;
  currentStep: number;
  completed: boolean;
  completedAt: string | null;
  updatedAt: string;
};

/** 워크스페이스의 전체 튜토리얼 진행 상태를 한 번에 조회 (튜토리얼 목록 배지용) */
export async function fetchTutorialProgressList(
  workspaceId: string
): Promise<TutorialProgressRow[]> {
  const id = (workspaceId || '').trim();
  if (!id) return [];
  const { data, error } = await supabase
    .from('tutorial_progress')
    .select('tutorial_id, current_step, completed, completed_at, updated_at')
    .eq('workspace_id', id);
  if (error) {
    // 네트워크 오류 등으로 실패해도 튜토리얼 진입 자체는 막지 않음(빈 목록 취급)
    console.warn('[tutorialProgressService] fetch failed', error.message);
    return [];
  }
  return (data ?? []).map((row) => ({
    tutorialId: String(row.tutorial_id ?? ''),
    currentStep: Number(row.current_step ?? 0),
    completed: Boolean(row.completed),
    completedAt: row.completed_at ?? null,
    updatedAt: String(row.updated_at ?? ''),
  }));
}

/** 스텝 이동/완료 처리 upsert. 실패해도 튜토리얼 진행 자체는 막지 않도록 호출부에서 fire-and-forget으로 사용 권장. */
export async function upsertTutorialProgress(
  workspaceId: string,
  tutorialId: string,
  currentStep: number,
  completed: boolean
): Promise<void> {
  const wsId = (workspaceId || '').trim();
  const tId = (tutorialId || '').trim();
  if (!wsId || !tId) return;
  const { error } = await supabase.rpc('upsert_tutorial_progress', {
    p_workspace_id: wsId,
    p_tutorial_id: tId,
    p_current_step: Math.max(0, Math.trunc(currentStep)),
    p_completed: completed,
  });
  if (error) {
    console.warn('[tutorialProgressService] upsert failed', error.message);
  }
}
